<template>
	<div class="page-property-history">
        <div class="page-property-history__header">
            <div class="container">
                <div class="leader-header" ref="propertiesHeader">
					<div class="leader-header__container leader-header__container--fixed leader-header__container-holder">
						<div class="leader-header__container-wrap">
							<div class="leader-header__breadcrumb leader-header__breadcrumb--property">
								<div class="leader-header__breadcrumb-wrap" ref="breadcrumbs">
									<a class="breadcrumbs__link" @click="goBack()">
										<SvgIcon class="breadcrumbs__icon" iconName="ico-arrow-left"/>
									</a>
									<span class="section-title section-title--breadcrumbs">
										<span class="page-property-history__image" v-if="propertyimgUrl"><img :src="propertyimgUrl" alt=""></span>
										<span class="page-property-history__image" v-else><img :src="placeholderImg" alt=""></span>
										<span class="page-property-history__title">{{ propertyName }}
											<span class="properties-header__name-contract" v-if="inContract">In Contract</span>
										</span>
									</span>
									<span class="leader-header-popup-icon" @click="showNote" ref="exclamation-mark">
										<SvgIcon class="leader-header_icon" iconName="ico-exclamation-mark"/>
										<PartNote v-on-click-outside.static="showNote" v-if="propertyDetails" :data="DataNote"/>
									</span>
								</div>
								<span class="leader-header__breadcrumb-count" v-if="counter > 1">{{ counter }} matches</span>
								<span class="leader-header__breadcrumb-count" v-else-if="counter === 1">{{ counter }} match</span>
							</div>
							<div class="leader-header__button">
								<!-- <div class="properties-header__half-btn properties-header__half-btn--download">
									<a :href="setHref(unpersonalized_pdf_url)" target="_blank">
										<div class="btn btn--white btn--lg" id="history-link">
											<SvgIcon class="property-history-header__file-icon" iconName="ico-pdf-file"/>
											<span>Download Flyer</span>
										</div>
									</a>
								</div> -->
								<div class="properties-header__half-btn">
									<router-link class="btn properties-header__info-btn" id="history-link" :to="{ name: goInDashboard() ? 'SinglePropertyAdmin' : 'SinglePropertyAgent', params: { id: $route.params.id } }">
										<span>Detailed Information</span>
									</router-link>
								</div>
								<div class="property-history-header__download-btn">
									<div id="document-picker">
										<div class="property-history-header__wrapper">
											<span class="property-history-header__wrapper-btn" @click="toggleDropdown()">
												<SvgIcon class="property-history-header__file-icon" iconName="ico-pdf-file"/>
												Download PDF
											</span>
											<ul class="property-history-header__dropdown" v-if="activeDrop" v-on-click-outside="close">
												<li class="property-history-header__dropdown-item" v-for="document in documents" :key="document.id">
													<a class="property-history-header__dropdown-link" v-if="document.show" :id="document.linkId" :href="document.docLink" :target="document.target">
														<span :style="{background: document.hex}"></span>
														{{document.name}}
													</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div class="leader-header__match">
									<a @click="popupToggle" :id="matchCustomerId" class="btn btn--white leader-header__match-btn">
										<span>{{ matchCustomerLabel }}</span>
									</a>
								</div>
								<router-link class="btn btn--sm btn--white" :to="{ name: 'EditProperty', params: { id: $route.params.id } }" v-if="checkPermissions()">
									<SvgIcon class="leader-header__button-icon" iconName="ico-edit"/>
									Edit
								</router-link>
								<!--<a class="btn submit-sm leader-header__button-arhive">
									<SvgIcon class="leader-header__button-icon" iconName="ico-arhive"/>
									Archive
								</a>-->
							</div>
						</div>
					</div>
					<div class="leader-header__container-holder"></div>
					<div class="leader-header__filters">
						<ul class="leader-header__filters-list">
							<li class="leader-header__filters-item" v-for="(group, index) in filters" :key="index">
								<span class="leader-header__filters-item-title"  @mouseover="infoPopup = true" @mouseleave="infoPopup = false">{{group.name}}
									<span class="leader-header__filters-item-popup-wrap">
										<SvgIcon class="leader-header__filters-item-info" v-if="(group.name === ' Building Size') || (group.name === 'Lot Size')" iconName="ico-exclamation-mark"/>
										<div class="leader-header__filters-item-popup">
											<span>
												The values have been automatically changed by the system, <br/> min -10% and max +20%!
											</span>
										</div>
									</span>
								:</span>
								<div class="leader-header__filters-item-pill" v-for="pill in group.labels" :key="pill.id" :class="{ 'leader-header__filters-item-pill--disable': !pill.show }" @click="deactivateFilterPill(group.key, pill)">
									<span class="leader-header__filters-item-pill-name">{{pill.value}}</span>
									<span>
										<SvgIcon class="delete-item-icon" iconName="ico-close-sm"/>
									</span>
								</div>
								<span @click="disableAllPills(group)" v-if="group.labels.length > 1">
									<SvgIcon class="delete-item-icon-all" iconName="ico-close-sm"/>
								</span>
							</li>
						</ul>
					</div>
				</div>
            </div>
        </div>
		<div class="container">
			<div class="page-property-history__header-matching-properties">
				<span class="section-title section-title--sm section-title--matching-properties">Matching Customers</span>
				<div class="notification-wrap-center">
					<PartNotifications :data="notificationsData" v-if="notificationsData.msg" />
				</div>
				
				<div class="page-property-history__header-matching-buttons">
					<div :class="{ 'select-stage': true, 'select-stage--disabled': !customPropertiesChangeStage.length > 0 }">
						<label>
							Change Stage:
						</label>
						<div class="select-stage__select-wrap">
							<div :class="{ 'select-stage__select': true, 'active': isVisible }" @click="toggleVisibility">
								<span class="dropdown__holder" :class="{'dropdown__holder--first-selected': currentSelected.name === ''}" :style="{background: currentSelected.color + ' !important', color: '#fff'}">
									<span v-if="currentSelected.name === '' && allStages.length > 0">{{allStages[0].title}}</span>
									{{ currentSelected.name }}
								</span>
								<span><SvgIcon class="select-stage__select-icon" iconName="ico-angle-down"/></span>
							</div>
							<!-- Stages dropdown -->
							<div
							class="dropdown_stages"
							v-on-click-outside="onClickOutside"
							v-if="isVisible">
								<transition name="fade">
									<ul class="dropdown">
										<li class="color-picker__item" v-for="(item) in allStages" :key="item.id">
											<a class="dropdown__link">
												<span class="color-picker__item-color" :style="{background: item.color}"></span>
												<span class="color-picker__item-text" @click="changeStageMany({stageRowId: currentSelected.id, stageRow: currentSelected.name, stage_id: item.id, stage_name: item.title }, item.title, item.datepicker, item.color)">
													{{ item.title }}
												</span>
											</a>
										</li>
									</ul>
								</transition>
							</div >
						</div>
					</div>
					<div class="header-matching-properties-button" v-if="showBlastEmail">
						<a class="btn btn--lg" @click="sendBlastEmailPopup">Send Blast Email</a>
					</div>
				</div>
			</div>
			<!-- <span class="header-matching-properties__selected-items">{{ customPropertiesChangeStage.length }} of customers selected</span> -->
			<span class="header-matching-properties__selected-items" :class="{ 'show': customPropertiesChangeStage.length > 0 }">
				{{ getIsAllSelected ? total : customPropertiesChangeStage.length }} 
				{{ customPropertiesChangeStage.length === 1 ? 'customer' : 'customers' }} selected
			</span>
		</div>
		<div class="container">
			<div class="table__container">
				<div class="table__item">
					<!-- Custom table accordion-custom-table -->
					<div class="accordion-custom-table">
						<div class="accordion-custom-table__item" ref="accordionArrow" :key="index">
							<ul class="accordion-custom-table__list-button">
								<li class="accordion-custom-table__inner-button" ref="iconAccordion">
									<a class="accordion-custom-table__button" @click="toggle">
										<div class="accordion-custom-table__button-name" :style="{background: data.buttonNameColor}">
											Lead
										</div>
										<span class="accordion-custom-table__button-num">
											{{ countLeadProperty > 1 ? countLeadProperty + ' Customers' : countLeadProperty + ' Customer' }}
										</span>
										<span class="accordion-custom-table__button-icon">
											<SvgIcon class="accordion-custom-table__button-arrow" iconName="ico-arrow-down"/>
										</span>
									</a>
								</li>
							</ul>
							<slide-up-down :active="active" :duration="800">
								<div class="accordion-custom-table__content">
									<BlockCustomTable
										:obj="dataTableIntro"
										ref="leadCustomers"
										:flagHide="true"
										@updateStage="updateStage"
										@showBlastEmail="setBlastEmail"
										@click="sortData($event, field.key)"
										@sendEmailPopup="sendEmailPopup"
										@sortData="sortLeads"
										@loadMore="loadMore"
										@onSortLead="onSortLead"
										:emptyCheckedRow="shouldEmptyCheckedRows"
										:sort="localOrderBy"
										@decreaseTotalSelected="decreaseTotalSelected"
										@inccreaseTotalSelected="inccreaseTotalSelected"
										:total="countLeadProperty"
										@updateActive="updateActive"
									/>
								</div>
							</slide-up-down>
						</div>
					</div>
				</div>
				<template v-if="Object.keys(this.allTables).length > 0">
					<div class="table__item" v-for="(table, index) in allTables" :key="index">
						<BlockAccordion
							:data="table"
							:index="index"
							:flagCheckbox="true"
							:infinitScrollFlag="infinitScrollFlag"
							@setAgainTable="setAgainTable"
							@noLeadUpdate="noLeadUpdate"
							@dismissStage="dismissStage"
							@showPopupNote="showPopupNote"
							@onSort="onSort"
							ref="stageTableRefs"
						/>
					</div>
				</template>
			</div>
		</div>

		<BlockPopupDetails
			@closePopupForm="closePopupForm"
			@showPopupNote="showPopupNote"
			:class="{'activeNote' : activeNote}"
			class="popups-content"
			:data="NoteData"
		/>
		<BlockPopupMatchCustomer
			v-if="showPopup"
			:data="DataMatchProperty"
			@closePopupCustomer="closePopupCustomer"
			@startFiltration="startFiltration"
			@loadMore="loadMore"
			@sendEmailPopup="sendEmailPopup"
			:parentType="parentType"
			:sort="localOrderBy"
		/>
		<PartPopupEmail
			ref="emailPopup"
			v-if="emailPopup"
			:data="DataPartPopupEmail"
			:isHistory="true"
			@closePopupEmail="closePopupEmail"
			@sendingEmail="sendingEmail"
			@afterSendEmail="afterSendEmail"
		/>
		<BlockFormPopup
			v-if="activePopup"
			:class="{'active' : activePopup}"
			:data="popupData"
			class="popups-content"
			@closePopupForm="closePopupFormFirst"
			@submitForm="submitForm"
		/>
		<PartLoaderBig v-if="preloader || infinitScrollFlag"/>
	</div>
</template>

<script>
import { getDemoAsset, formatNumber, formatDate } from '@/config/util';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import PartNote from '@/components/parts/PartNote';
import BlockCustomTable from '@/components/blocks/BlockCustomTable';
import BlockAccordion from '@/components/blocks/BlockAccordion';
import { mixin as onClickOutside } from 'vue-on-click-outside';
import { check } from '@/services/RouteGuards/SuperAdmin';
import BlockPopupDetails from '@/components/blocks/BlockPopupDetails';
import BlockPopupMatchCustomer from '@/components/blocks/BlockPopupMatchCustomer';
import PartPopupEmail from '@/components/parts/PartPopupEmail';
import SlideUpDown from 'vue-slide-up-down';
import PartNotifications from '@/components/parts/PartNotifications';
import PartLoaderBig from '@/components/parts/PartLoaderBig';
import BlockFormPopup from '@/components/blocks/BlockFormPopup';

export default {
	props: {
		data: {
			type: Object,
			required: true
		},
		sort: {
			type: String,
			required: false
		}
	},
	data () {
		return {
			allTablesCount: {},
			isVisible: false,
			preventGetPage: false,
			// stages
			stagesData: {
				label: 'Change Stage:',
				placeholder: 'Add Agent',
				inputId: 'stage-select',
				labelId: 'stage-select-label',
				mandatoryFiled: false,
				options: [
					{ label: 'Option 1', value: 'option1' },
					{ label: 'Option 2', value: 'option2' },
					{ label: 'Option 3', value: 'option3' }
				]
			},
			activePopup: false,
			popupData: {
				popupId: 'popup_emailed',
				popupTitle: '',
				DataNoteArea: {
					label: 'Notes',
					inputId: 'note-popup-input',
					labelId: 'note-popup-label',
					classTextarea: 'small-area'
				},
				showCalendar: false,
				DataCalendar: {
					label: '',
					inputId: 'date_calendar-input',
					labelId: 'date_calendar-label',
					icon: true
				}
			},
			stageMany: [],
			isLoadingCustomStageMany: false,
			// PDF
			documents: [
				{
					name: 'Agent Version',
					docLink: `${process.env.VUE_APP_BACKEND_URL}/pdf/agent/download/${this.$route.params.id}`,
					target: '_blank',
					linkId: 'agent',
					show: true
				},
				{
					name: 'Client Version',
					docLink: `${process.env.VUE_APP_BACKEND_URL}/pdf/client/download/${this.$route.params.id}`,
					target: '_blank',
					linkId: 'client',
					show: true
				}
			],
			activeDrop: false,
			inContract: false,
			preloader: false,
			active: true,
			index: '1',
			emailPopup: false,
			DataPartPopupEmail: {},
			showPopup: false,
			notificationsData: {
				type: '',
				msg: ''
			},
			matchCustomerId: 'matchCustomerId',
			matchCustomerLabel: 'Match Customer',
			DataMatchProperty: {
				popupTitle: 'Match Customer',
				preloader: false,
				DataMatchCustomer: {
					stickyHeader: true,
					noCollapse: false,
					// noLocalSorting: true,
					tableClass: 'text-nowrap',
					fields: [
						{ key: 'last_name', sortable: true, stickyColumn: true, label: 'Name', sortOrder: 'asc' },
						{ key: 'company_name', sortable: true, stickyColumn: true, label: 'Company Name' },
						{ key: 'offering_type_label', sortable: true, stickyColumn: true, label: 'Offering Type' },
						{ key: 'area_label', sortable: true, stickyColumn: true, label: 'Area' },
						{ key: 'critical_note', sortable: true, stickyColumn: true, label: 'Critical Notes' },
						{ key: 'property_type_label', sortable: true, stickyColumn: true, label: 'Type' },
						{ key: 'building_size_min', sortable: true, stickyColumn: true, label: 'Bldg Size Min' },
						{ key: 'building_size_max', sortable: true, stickyColumn: true, label: 'Bldg Size Max' },
						{ key: 'lot_size_min', sortable: true, stickyColumn: true, label: 'Lot Size Min' },
						{ key: 'lot_size_max', sortable: true, stickyColumn: true, label: 'Lot Size Max' },
						{ key: 'price_min', sortable: true, stickyColumn: true, label: 'Price Min' },
						{ key: 'price_max', sortable: true, stickyColumn: true, label: 'Price Max' },
						{ key: 'price_buildable_sf_min', sortable: true, stickyColumn: true, label: 'Price per Buildable SF Min' },
						{ key: 'price_buildable_sf_max', sortable: true, stickyColumn: true, label: 'Price per Buildable SF Max' },
						{ key: 'price_psf_min', sortable: true, stickyColumn: true, label: 'Price per SF Min' },
						{ key: 'price_psf_max', sortable: true, stickyColumn: true, label: 'Price per SF Max' },
						{ key: 'lease_price_min', sortable: true, stickyColumn: true, label: 'Lease Price Min' },
						{ key: 'lease_price_max', sortable: true, stickyColumn: true, label: 'Lease Price Max' },
						{ key: 'yearly_price_min', sortable: true, stickyColumn: true, label: 'Yearly Price per SF Min' },
						{ key: 'yearly_price_max', sortable: true, stickyColumn: true, label: 'Yearly Price per SF Max' },
						{ key: 'end_user', sortable: true, stickyColumn: true, label: 'End User' }
					],
					items: []
				},
				DataSearch: {
					label: '',
					placeholder: 'Search...',
					labelId: 'popup-property-search-label',
					inputId: 'popup-property-search-input'
				}
			},
			propertyDetails: false,
			classScroll: 'prevent-scroll',
			dataTableIntro: {
				customersLead: true,
				stageTable: true,
				checkboxes: true,
				stickyHeader: true,
				// noLocalSorting: true,
				noCollapse: false,
				tableClass: 'text-nowrap',
				fields: [
					{ key: 'last_name', label: 'Name', sortable: true, stickyColumn: true, sortOrder: 'asc' },
					{ key: 'stage', sortable: true, stickyColumn: true, label: 'Stage' },
					// { key: 'source', label: 'Source' },
					{ key: 'area_label', sortable: true, stickyColumn: true, label: 'Area' },
					{ key: 'property_type_label', sortable: true, stickyColumn: true, label: 'Property Type' },
					{ key: 'price_min', sortable: true, stickyColumn: true, label: 'Price Min' },
					{ key: 'price_max', sortable: true, stickyColumn: true, label: 'Price Max' },
					{ key: 'price_buildable_sf_min', sortable: true, stickyColumn: true, label: 'Price per Buildable SF Min' },
					{ key: 'price_buildable_sf_max', sortable: true, stickyColumn: true, label: 'Price per Buildable SF Max' },
					{ key: 'price_psf_min', sortable: true, stickyColumn: true, label: 'Price per SF Min' },
					{ key: 'price_psf_max', sortable: true, stickyColumn: true, label: 'Price per SF Max' },
					{ key: 'lease_price_min', sortable: true, stickyColumn: true, label: 'Lease Price Min' },
					{ key: 'lease_price_max', sortable: true, stickyColumn: true, label: 'Lease Price Max' },
					{ key: 'yearly_price_min', sortable: true, stickyColumn: true, label: 'Yearly Price per SF Min' },
					{ key: 'yearly_price_max', sortable: true, stickyColumn: true, label: 'Yearly Price per SF Max' },
					{ key: 'note', sortable: true, stickyColumn: true, label: 'Note' },
					{ key: 'primary_phone', sortable: true, stickyColumn: true, label: 'Phone' },
					{ key: 'created_at', sortable: true, stickyColumn: true, label: 'Date' }
				],
				items: [],
				history: true
			},
			picked: false,
			DataNote: {
				noteTitle: 'About Property',
				items: []
			},
			propertyName: '',
			propertyimgUrl: '',
			unpersonalized_pdf_url: '',
			placeholderImg: getDemoAsset('property/placeholder-50x50.png'),
			allTables: {},
			formatSF: ['matching_lot_size_min', 'matching_lot_size_max'],
			formatPrice: ['matching_price_min', 'matching_price_max'],
			NoteData: {
				popupDetailsTitle: 'Notes',
				items: []
			},
			activeNote: false,
			loadMoreActive: false,
			savedFilter: '',
			counter: 0,
			localOrder: 'asc',
			localOrderBy: 'last_name',
			parentType: 'property',
			showBlastEmail: false,
			checkedRows: null,
			active_filters: null,
			helperFilters: [],
			infinitScrollFlag: false,
			shouldEmptyCheckedRows: false,
			total: 0
		};
	},
	components: {
		SvgIcon,
		PartNote,
		BlockCustomTable,
		BlockAccordion,
		BlockPopupDetails,
		BlockPopupMatchCustomer,
		PartPopupEmail,
		SlideUpDown,
		PartNotifications,
		PartLoaderBig,
		BlockFormPopup
	},
	mixins: [onClickOutside],
	beforeMount() {
		this.$store.dispatch('resetInititalProperty', true);
	},
	async mounted() {
		this.preloader = true;
		const obj = {
			filter: this.filter,
			order_by: 'last_name',
			order: 'asc',
			id: this.$route.params.id,
			page: 1
		};
		await Promise.all([
			this.$store.dispatch('fetchStages'),
			this.$store.dispatch('matchingProperties', obj)
			// this.$store.dispatch('customersForMatching', obj)
		]);
		this.preloader = false;
		this.equalHeights('leader-header__container-holder');
		this.documents.push({
			name: 'Eretz Flyer',
			docLink: `${process.env.VUE_APP_BACKEND_URL}/custom/download?id=${JSON.parse(localStorage.getItem('user')).id}&url=${this.propertyInfo.unpersonalized_pdf_url}`,
			target: '_blank',
			linkId: 'flyer',
			show: true
		});
	},
	computed: {
		leadsCount() {
			return this.$store.getters.getLeadsCountProperty;
		},
		leadsPagination() {
			return this.$store.getters.getLeadsPaginationProperty;
		},
		matches() {
			return this.$store.getters.getMatchesProperties;
		},
		filters() {
			return this.$store.getters.getFiltersProperties;
		},
		customersForMatching() {
			return this.$store.getters.getCustomersForMatching;
		},
		propertyInfo() {
			return this.$store.getters.getPropertyInfo;
		},
		allStages() {
			return this.$store.getters.getStages;
		},
		customPropertiesChangeStage() {
			return this.$store.getters.getCustomPropertiesChangeStage;
		},
		currentSelected() {
			return this.$store.getters.getCurrentSelected;
		},
		countLeadProperty() {
			return this.$store.getters.getCountLeadPropertyProperty;
		},
		getIsAllSelected() {
			return this.$store.getters.getIsAllSelected;
		},
		getTotalSelectedInStage() {
			return this.$store.getters.getTotalSelectedInStage;
		}
	},
	watch: {
		activePopup(val) {
			if (!val) {
				this.stageMany = [];
			}
		},
		getTotalSelectedInStage() {
			this.total = this.getTotalSelectedInStage.total;
		},
		countLeadProperty() {
			this.counter = this.countLeadProperty;
		},
		matches() {
			if (this.isLoadingCustomStageMany) {
				this.$refs.leadCustomers.resetSelectedCustomersNew();
			}
			this.init();
			this.counter = this.countLeadProperty;
			if (this.counter > 0) {
				this.active = true;
				this.$refs.accordionArrow.classList.add('is-open');
			} else {
				this.active = false;
				this.$refs.accordionArrow.classList.remove('is-open');
			}
			this.DataNote.items.forEach((ele) => {
				if (ele.info === 'In contract') {
					this.inContract = true;
				}
			});
		},
		customersForMatching() {
			this.DataMatchProperty.preloader = false;
			this.DataMatchProperty.DataMatchCustomer.items = this.customersForMatching.customers;
		},
		accordionCustomTable() {
			this.accordionArrow();
		}
	},
	created () {
		const user = JSON.parse(localStorage.getItem('user'));
		if (localStorage.getItem('filter-property') && JSON.parse(localStorage.getItem('filter-property')).user_id === user.id) {
			this.filter = JSON.parse(localStorage.getItem('filter-property')).filter;
			this.$emit('startFiltration', this.filter);		
		} 
		window.addEventListener('scroll', this.handleSCroll);
	},
	destroyed () {
		window.removeEventListener('scroll', this.handleSCroll);
	},
	methods: {
		async setAgainTable(obj) {
			this.infinitScrollFlag = true;
			const objForStagePaginationRequest = {
				active_filters: this.filters,
				order_by: obj.sortBy.replace('_label', '').replace('_customer', ''),
				order: obj.order,
				id: this.$route.params.id,
				stage: obj.stageId,
				page: obj.page
			};
			await this.$store.dispatch('matchingPropertiesByStage', objForStagePaginationRequest);
			this.infinitScrollFlag = false;
			this.init();
		},
		async onSort(obj) {
			this.infinitScrollFlag = true;
			const objForStagePaginationRequest = {
				active_filters: this.filters,
				order_by: obj.sortBy.replace('_label', '').replace('_customer', ''),
				order: obj.order,
				id: this.$route.params.id,
				stage: obj.stageId,
				page: obj.page
			};
			await this.$store.dispatch('matchingPropertiesByStage', objForStagePaginationRequest);
			this.infinitScrollFlag = false;
			this.init();
		},
		submitForm(data) {
			this.stageMany.forEach(item => {
				item.history[0].body = data.note;
			});
			this.isLoadingCustomStageMany = true;
			this.updateStage(this.stageMany, false);
			this.activePopup = false;
			this.stageMany = [];
			this.closePopupFormFirst();
			this.notificationsData.msg = 'Changed stage successfully!';
			this.notificationsData.type = 'success';
			setTimeout(() => {
				this.notificationsData.msg = '';
				this.notificationsData.type = '';
				this.isLoadingCustomStageMany = false;
			}, 2000);
			this.isAll = false;
		},
		closePopupFormFirst() {
			this.activePopup = false;
			this.shouldEmptyCheckedRows = false;
		},
		decreaseTotalSelected() {
			this.counter = this.counter - 1;
		},
		inccreaseTotalSelected() {
			this.counter = this.counter + 1;
		},
		changeStageMany(obj, title, datepicker, color) {
			this.isAll = true;
			this.customPropertiesChangeStage.forEach(item => {
				const newObj = {
					customer_id: item.customer_id,
					property_id: item.property_id,
					stage_id: obj.stage_id,
					stage_name: obj.stage_name,
					stageRow: obj.stageRow,
					stageRowId: obj.stageRowId,
					history: [
						{
							stage: obj.stage_name,
							popup_date: datepicker
						}
					]
				};
				this.stageMany.push(newObj);
			});
			this.popupData.popupTitle = title;
			this.popupData.showCalendar = datepicker;
			this.activePopup = true;
		},
		toggleVisibility() {
			this.isVisible = !this.isVisible;
		},
		onClickOutside() {
			this.isVisible = false;
		},
		setHref(url) {
			const agent = JSON.parse(localStorage.getItem('user'));
			return `${process.env.VUE_APP_BACKEND_URL}/custom/download?id=${agent.id}&url=${url}`;
		},
		handleSCroll (event) {
			const header = document.querySelector('.leader-header__container-holder');
			if (window.scrollY > 50 && !header.className.includes('leader-header__container-scroll')) {
				header.classList.add('leader-header__container-scroll'); 
			} else if (window.scrollY < 50) {
				header.classList.remove('leader-header__container-scroll');
			}
		},
		equalHeights: (elName) => {
			setTimeout(() => {
				const products = document.getElementsByClassName(elName);
				let x = 0;
				Array.from(products).forEach((el) => {
					el.style.height = 'auto';
					if (el.offsetHeight > x) {
						x = el.offsetHeight + 20;
					}
				});
				Array.from(products).forEach((el) => {
					el.style.height = `${x}px`;
				});
			}, 100);
		},
		toggleDropdown: function() {
			this.activeDrop = !this.activeDrop;
		},
		open() {
			this.activeDrop = true;
		},
		close() {
			this.activeDrop = false;
		},
		toggle() {
			this.active = !this.active;
			if (!this.active) {
				this.$refs.accordionArrow.classList.remove('is-open');
			} else {
				this.$refs.accordionArrow.classList.add('is-open');
			}
		},
		updateActive(newActiveValue) {
			this.active = newActiveValue;
		},
		accordionArrow() {
			if (!this.active) {
				this.$refs.accordionArrow.classList.remove('is-open');
			} else {
				this.$refs.accordionArrow.classList.add('is-open');
			}
		},
		init() {
			this.dataTableIntro.items = this.matches.lead;
			if (Object.keys(this.allTables).length === 0) {
				this.initTableStage();
			} else {
				this.fillTables();
			}
			this.fillAbout(this.propertyInfo);
		},
		fillAbout(data) {
			this.propertyName = data.property_name;
			this.propertyimgUrl = data.image;
			this.unpersonalized_pdf_url = data.unpersonalized_pdf_url;
			this.DataNote.items = [
				{ label: 'Building Size:', info: data.building_size ? data.building_size + ' SF' : '' },
				{ label: 'Lot Size:', info: data.lot_size ? data.lot_size + ' SF' : '' },
				// { label: 'Price per Square Foot:', info: data.price_per_sf ? '$' + this.formatDollars(data.price_per_sf) : '' },
				{ label: 'Listing Status:', info: data.listing_status },
				{ label: 'Listing Type:', info: data.listing_type },
				{ label: 'Date Listed:', info: data.date_added ? this.changeDateFormat(data.date_added) : '' },
				{ label: 'Date Updated:', info: data.date_update ? this.changeDateFormat(data.date_update) : '' }
			];
			if (data.offering_type.includes('lease') && data.offering_type.includes('sale')) {
				this.DataNote.items.unshift({ label: 'Yearly Price Per SF:', info: data.yearly_price ? '$' + this.formatDollars(data.yearly_price) : '' });
				this.DataNote.items.unshift({ label: 'Lease Price:', info: data.lease_price ? '$' + this.formatDollars(data.lease_price) : '' });
				this.DataNote.items.unshift({ label: 'Price:', info: data.regular_price ? '$' + this.formatDollars(data.regular_price) : '' });
			} else if (data.offering_type.includes('sale')) {
				this.DataNote.items.unshift({ label: 'Price:', info: data.regular_price ? '$' + this.formatDollars(data.regular_price) : '' });
			} else if (data.offering_type.includes('lease')) {
				this.DataNote.items.unshift({ label: 'Yearly Price Per SF:', info: data.yearly_price ? '$' + this.formatDollars(data.yearly_price) : '' });
				this.DataNote.items.unshift({ label: 'Lease Price:', info: data.lease_price ? '$' + this.formatDollars(data.lease_price) : '' });
			}
		},
		initTableStage() {
			this.leadsCount.forEach((item) => {
				this.allStages.forEach((stage) => {
					if (stage.id === item.stage_id && stage.title !== 'Lead') {
						this.createTableStage(stage.title, [], `${stage.title.replace('st_', '').replaceAll('_', ' ')}`, item.count, stage.color, stage.id);
					}
				});
			});
		},
		fillTables() {
			this.leadsCount.forEach((item) => {
				this.allStages.forEach((stage) => {
					if (stage.id === item.stage_id && stage.title !== 'Lead') {
						const revertName = `st_${stage.title.replaceAll(' ', '_')}`;
						const stageItems = this.matches.stages[revertName] ?? [];
						this.createTableStage(stage.title, stageItems, stage.title, item.count, stage.color, stage.id);
					}
				});
			});

			this.allTablesCount = this.leadsCount.map((item) => {
				const newStage = {};
				this.allStages.forEach((stage) => {
					if (stage.id === item.stage_id) {
						newStage.title = stage.title;
						newStage.count = item.count;
					}
				});
				return newStage;
			});

			this.$forceUpdate();
		},
		createTableStage(flag, stage, stageName, count, color, stageId) {
			this.allTables[flag] = {
				buttonName: stageName,
				buttonNameColor: color,
				stageId: stageId,
				userNum: count > 1 ? count + ' Customers' : count + ' Customer',
				sort: 'last_name',
				total: count,
				DataAccordionTable: {
					stageTable: true,
					stickyHeader: true,
					noCollapse: false,
					tableClass: 'text-nowrap',
					// noLocalSorting: false,
					fields: [
						{ key: 'last_name', label: 'Name', flag: 'match', stickyColumn: true, sortable: true, variant: 'property thead-lg' },
						{ key: 'stage_icon', label: 'Stage', sortable: false, stickyColumn: true, variant: 'stage' },
						{ key: 'area_label', label: 'Area', sortable: true, stickyColumn: true, variant: 'area' },
						// { key: 'source', label: 'Source', sortable: true, variant: 'source' },
						{ key: 'property_type_label', label: 'Property Type', stickyColumn: true, sortable: true, variant: 'property-type' },
						{ key: 'price_min', label: 'Price Min', stickyColumn: true, sortable: true, variant: 'price' },
						{ key: 'price_max', label: 'Price Max', stickyColumn: true, sortable: true, variant: 'price' },
						{ key: 'price_buildable_sf_min', label: 'Price per Buildable SF Min', stickyColumn: true, sortable: true, variant: 'price-buildable-sf' },
						{ key: 'price_buildable_sf_max', label: 'Price per Buildable SF Max', sortable: true, variant: 'price-buildable-sf' },
						{ key: 'price_psf_min', label: 'Price per SF Min', stickyColumn: true, sortable: true, variant: 'price-psf' },
						{ key: 'price_psf_max', label: 'Price per SF Max', stickyColumn: true, sortable: true, variant: 'price-psf' },
						{ key: 'lease_price_min', label: 'Lease Price Min', stickyColumn: true, sortable: true, variant: 'lease-price' },
						{ key: 'lease_price_max', label: 'Lease Price Max', stickyColumn: true, sortable: true, variant: 'lease-price' },
						{ key: 'yearly_price_min', label: 'Yearly Price per SF Min', stickyColumn: true, sortable: true, variant: 'yearly-price' },
						{ key: 'yearly_price_max', label: 'Yearly Price per SF Max', stickyColumn: true, sortable: true, variant: 'yearly-price' },
						{ key: 'note', label: 'Note', stickyColumn: true, sortable: true, variant: 'note' },
						{ key: 'primary_phone', label: 'Phone', sortable: true, stickyColumn: true, variant: 'phone' },
						{ key: 'created_at', label: 'Date', sortable: true, stickyColumn: true, variant: 'date' },
						{ key: 'delete-stage', label: '', sortable: false, stickyColumn: true, variant: 'fixed-icon first-icon-fixed last-icon-fixed delete ' }
					],
					items: stage
				}
			};
		},

		// Delete table when its empty
		deleteTableStage(flag) {
			delete this.allTables[flag];
		},
		// Update stages from Lead to any other stage and remove stage from Lead table
		async updateStage(obj, flag) {
			const adminOrAgent = this.leadsPagination;
			this.infinitScrollFlag = true;
			if (this.helperFilters.length && flag) {
				obj.active_filters = this.active_filters;
			}

			await this.$store.dispatch('assignPropertyToStageNew', { 
				req: (flag) ? [obj] : obj, 
				stages: this.allStages,
				filter: this.filters,
				id: this.$route.params.id,
				page: 1,
				order_by: adminOrAgent.sort_by.replace('_label', '').replace('_customer', ''),
				order: adminOrAgent.order
			}).then((res) => {
				if (res.req[0].stage_name === 'Lead') {
					this.$refs.leadCustomers && this.$refs.leadCustomers.scrollTo && this.$refs.tableCustom.scrollTo({ top: 0 });
				}
			});
			this.allTables = {};
			setTimeout(() => {
				this.init();
				this.$forceUpdate();
			}, 100);
			this.$store.dispatch('resetCustomPropertiesChangeStage');
			this.infinitScrollFlag = false;
			this.shouldEmptyCheckedRows = true;
		},

		// Update stages from not Lead to any other stage
		noLeadUpdate(obj) {
			this.updateStage(obj, true);
		},

		// Move property to dismiss stage
		dismissStage(obj) {
			this.$store.dispatch('assignCustomerToStage', obj);
		},
		showNote() {
			this.propertyDetails = !this.propertyDetails;
			if (this.isOpened === true) {
				this.isOpened = false;
			}
		},
		hideNote() {
			this.$refs.breadcrumbs.classList.remove('show-note');
		},
		goInDashboard() {
			return this.$route.fullPath.includes('admin');
		},
		checkPermissions() {
			return check();
		},
		disableAllPills(group) {
			const flag = 'group';
			let groupStatus = true;
			group.labels.forEach(pill => {
				if (!pill.show) {
					groupStatus = false;
				}
			});
			group.labels.forEach(pill => {
				this.deactivateFilterPill(group.key, pill, flag, groupStatus);
			});	
		},
		async deactivateFilterPill(key, item, flag, status = true) {
			this.localOrderBy = this.localOrderBy.replace('_label', '').replace('_customer', '');
			this.preloader = true;
			this.dataTableIntro.items = [];
			this.preventGetPage = true;
			this.$store.dispatch('setLeadsPaginationAction', { data: { current_page: 1 }, paginationInfo: { sort_by: this.localOrderBy ?? 'last_name', order: this.localOrder ?? 'asc' } });
			for (const refKey in this.$refs.stageTableRefs) {
				if (Object.prototype.hasOwnProperty.call(this.$refs.stageTableRefs, refKey)) {
					this.$refs.stageTableRefs[refKey].openAccordion('st_Lead');
				}
			}

			const obj = {
				key: key,
				item: item
			};
			if (flag) {
				obj.flag = flag;
			}

			if (obj.flag === 'group') {
				obj.status = status;
				await this.$store.dispatch('enablePillsProperties', obj);
			} else {
				await this.$store.dispatch('togglePillsProperties', obj);
			}

			if (!obj.item.show) {
				this.helperFilters.push(obj);
			} else {
				let index;
				this.helperFilters.forEach(el => {
					index = this.helperFilters.findIndex(el => el.key === obj.key && el.item.value === obj.item.value);
				});
				this.helperFilters.splice(index, 1);
			}

			// If some filter pill is turn off send active filters to BE
			if (this.helperFilters.length) {
				this.active_filters = this.filters;
				await this.$store.dispatch('mutationFiltersProperties', { id: this.$route.params.id, active_filters: this.active_filters, page: 1, order_by: this.localOrderBy ?? 'last_name', order: this.localOrder ?? 'asc' });
				this.preloader = false;
			} else {
				this.active_filters = null;
				await this.$store.dispatch('mutationFiltersProperties', { id: this.$route.params.id, active_filters: this.active_filters, page: 1, order_by: this.localOrderBy ?? 'last_name', order: this.localOrder ?? 'asc' });
				this.preloader = false;
			}
			this.$emit('sortData', false);	
		},
		formatDollars(field) {
			return formatNumber(field);
		},
		changeDateFormat(date) {
			return formatDate(date);
		},
		showPopupNote(pivot) {
			this.$store.dispatch('stageHistory', pivot).then(res => {
				this.NoteData.items = res.data.history;
				this.NoteData.pivot = pivot;
				this.activeNote = !this.activeNote;
				this.$refs.propertiesHeader.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.add(this.classScroll);
			});
		},
		closePopupForm() {
			this.activeNote = false;
			this.$refs.propertiesHeader.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.remove(this.classScroll);
		},
		popupToggle() {
			this.showPopup = true;
			this.$refs.propertiesHeader.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.add(this.classScroll);
		},
		closePopupCustomer() {
			this.showPopup = false;
			this.$refs.propertiesHeader.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.remove(this.classScroll);		
		},
		startFiltration(data) {
			this.DataMatchProperty.preloader = true;
			const obj = {
				filter: {
					search: data
				},
				id: this.$route.params.id,
				page: 1
			};
			this.savedFilter = data;
			this.$store.dispatch('customersForMatching', obj).then(res => {
				this.DataMatchProperty.DataMatchCustomer.items = res.data.customers;
				this.DataMatchProperty.preloader = false;
				this.$root.$emit('sortData');
			});
		},
		// Load more properties if prev loadMore finish and if we have next page
		async loadMore() {
			const adminOrAgent = this.leadsPagination;
			let nextPage = adminOrAgent.current_page++;
			(adminOrAgent.current_page === 0)
				? nextPage = 1
				: nextPage = adminOrAgent.current_page++;
			if (this.infinitScrollFlag || nextPage > adminOrAgent.last_page) {
				this.preventGetPage = false;
				return false;
			}

			this.infinitScrollFlag = true;
			await this.$store.dispatch('matchingProperties', { 
				active_filters: this.filters,
				id: this.$route.params.id,
				page: nextPage,
				order_by: this.localOrderBy.replace('_label', '').replace('_customer', ''),
				order: this.localOrder
			});
			this.infinitScrollFlag = false;
			this.init();
		},
		async onSortLead(obj) {
			this.infinitScrollFlag = true;
			const objForStagePaginationRequest = {
				active_filters: this.filters,
				order_by: obj?.sortBy?.replace('_label', '').replace('_customer', '') ?? 'last_name',
				order: obj.order,
				id: this.$route.params.id,
				page: 1
			};
			await this.$store.dispatch('matchingProperties', objForStagePaginationRequest);
			this.infinitScrollFlag = false;
			this.init();
		},
		sortData() {
			this.$emit('sortData');
		},
		sortLeads(item) {
			const obj = {
				order_by: item.sortBy.replace('_label', '').replace('_customer', ''),
				order: this.SortOrder(),
				id: this.$route.params.id,
				page: 1,
				active_filters: this.active_filters
			};
			this.dataTableIntro.fields.forEach(el => {
				if (el.key === item) {
					el.sortOrder = obj.order;
				} else {
					delete el.sortOrder;
				}
			});

			this.localOrderBy = item.sortBy;
			// this.$store.dispatch('sortPropertiesLeads', obj);
		},
		SortOrder() {
			if (this.localOrder === 'asc') {
				this.localOrder = 'desc';
			} else {
				this.localOrder = 'asc';
			}
			return this.localOrder;
		},
		setBlastEmail(checkedRows) {
			this.showBlastEmail = checkedRows.length > 1;
			this.checkedRows = checkedRows;
		},
		sendEmailPopup(pivot) {
			this.emailPopup = true;
			// Pass pivot data from row in custom table
			this.DataPartPopupEmail.pivot = pivot;
			this.DataPartPopupEmail.pivot.eretzPdf = this.propertyInfo.eretz_pdf;
			this.DataMatchProperty.pivot = pivot;
			// Pass filters
			if (!pivot.manualFlag) {
				this.DataPartPopupEmail.active_filters = this.active_filters;
			}
		},
		sendBlastEmailPopup(pivot) {
			this.emailPopup = true;
			this.DataPartPopupEmail.pivot = pivot;
			this.DataPartPopupEmail.pivot.eretzPdf = this.propertyInfo.eretz_pdf;
			this.DataMatchProperty.pivot = pivot;
			this.DataPartPopupEmail.active_filters = this.active_filters;
			this.DataPartPopupEmail.pivot = {
				origin: this.$route.fullPath.includes('properties') ? 'property' : 'customer',
				eretzPdf: this.propertyInfo.eretz_pdf
			};
			this.DataPartPopupEmail.sendBlast = true;
			this.DataPartPopupEmail.blastEmail = {
				customers_id: this.checkedRows,
				property_id: this.$route.params.id
			};
		},
		closePopupEmail(notification) {
			this.infinitScrollFlag = false;
			if (notification) {
				this.notification(notification);
			}
			this.$refs.propertiesHeader.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.remove(this.classScroll);
			this.preloader = false;
			this.emailPopup = false;
			// Reset blast flag from popup on close
			this.DataPartPopupEmail.active_filters = null;
			this.DataPartPopupEmail.sendBlast = false;
			this.closePopupCustomer();
		},
		notification(response) {
			this.notificationsData.msg = response.message;
			this.notificationsData.type = response.status === 200 ? 'success' : 'danger';

			setTimeout(() => {
				this.notificationsData.msg = '';
				this.notificationsData.type = '';
			}, 2000);
		},
		sendingEmail() {	
			this.infinitScrollFlag = true;
			this.$refs.propertiesHeader.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.add(this.classScroll);
			this.preloader = false;
			this.$refs.leadCustomers.resetSelectedCustomers();
			this.$refs.emailPopup.uploading = true;
			this.shouldEmptyCheckedRows = false;
		},
		afterSendEmail() {
			this.initTableStage();
			this.$forceUpdate();
			this.shouldEmptyCheckedRows = true;
		},
		goBack() {
			this.$router.go(-1);
			setTimeout(() => {
				location.reload();
			}, 500);
		}
	}
};
</script>
<style lang="scss" scoped>

.section-title--matching-properties {
	display: flex;
	align-items: center;
}
.select-stage {
	display: flex;
	align-items: center;
	@include mq($sm) {
		margin-left: auto;
	}
	label {
		color: $fiord;
		font-family: $font-main;
		font-size: 14px;
		line-height: 20px;
		font-weight: 400;
		margin-right: 8px;
	}

	&.select-stage--disabled {
		opacity: 0.5;
		pointer-events: none;
	}
}
.select-stage__select-wrap {
	position: relative;
	cursor: pointer;
	.dropdown_stages {
		right: 0;
		left: auto;
		top: 102%;
		position: absolute !important;
		
		@include mq(640px) {
			transform: none;
		}
	}
	.color-picker__item {
		&:last-of-type {
			margin-bottom: 0;
		}
	}
	.dropdown__link {
		padding-left: 0;
	}
	.dropdown__holder {
		min-width: 66px;

		span,
		&::before,
		&::after {
			transition: $dur $ease;
		}

		&.dropdown__holder--first-selected {
			background-color: rgb(255, 152, 0);
		}
	}
}
.select-stage__select {
	border: 1px solid $grey-light;
	padding: 10px 16px 10px 12px;
	border-radius: 8px;
	position: relative;
	display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 170px;
	&.active {
		.select-stage__select-icon {
			/deep/ {
				svg {
					transform: rotate(180deg);
				}
			}
		}
	}
}
.select-stage__select-icon {
	
	/deep/ {
		svg {
			height: 10px;
			width: 10px;
			color: $fiord;
		}
	}
}
.leader-header {
	display: flex;
	flex-direction: column;
}

.page-property-history__header {
	border-bottom: 1px solid $grey-light;
	margin-bottom: 10px;

	@include mq(1540px) {
		padding: 15px 0;
	}

	@include mq($lg) {
		padding: 0 0 15px;
		margin-bottom: 20px;
	}
}

.properties-header__half-btn--download {
	margin: 0 15px;

	@include mq($md) {
		margin: 10px 7px;
	}
}

/*--------------------------------------------------------------
## Blast email Popup
--------------------------------------------------------------*/
.blast-email-popup {
	position: fixed;
    top: 0;
    left: 0;
	bottom: 0;
	right: 0;
    width: 100%;
    height: 100vh;
    z-index: 999999;
    background-color: rgba($slate-gray, .5);
}

.blast-email-popup__wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.blast-email-popup__overlay {
	position: fixed;
    top: 0;
    left: 0;
	bottom: 0;
	right: 0;
    width: 100%;
    height: 100vh;
    z-index: -1;
    background-color: rgba($slate-gray, .5);
}

.blast-email-popup__container {
    max-width: 475px;
    padding: 21px 27px 28px 21px;
    width: 100%;
    background-color: $white;
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 4px rgba($black, .25);
    border-radius: 8px;
    position: relative;

    @include mq($lg) {
        padding: 40px 30px;
		margin: 0 15px;
    }

    @include mq(830px) {
        padding: 40px 15px;
    }

	.blast-email-popup__btn {
		max-width: 96px;
		margin-left: auto;
	}
}

.blast-email-popup-title {
	font-family: $font-second;
	font-weight: 500;
	font-size: 20px;
	line-height: 23px;
	color: $fiord;
	text-align: left;
}

.close-icon {
    position: absolute;
    right: 15px;
    top: 15px;
	color: $fiord;
	font-size: 20px;
	transition: $dur $ease;
	cursor: pointer;

	@include hover {
		color: $dodger-blue;
	}
}
.header-matching-properties-button {
	margin-left: 10px;

	@include mq(830px) {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	@include mq(530px) {
		margin-left: 0;
		margin-top: 10px;
	}
}

/*--------------------------------------------------------------
## Custom table accordion-custom-table
--------------------------------------------------------------*/
.accordion-custom-table__button {
	display: flex;
	background-color: $white-lilac;
	padding: 11px 43px 11px 13px;
	margin-top: 25px;
	position: relative;
	align-items: center;
	text-decoration: none;
	transition: $dur $ease;

	@include mq($lg) {
		flex-wrap: wrap;
	}

	@include mq(350px) {
		padding: 11px 43px 11px 7px;
		margin-top: 20px;
	}

	@include hover  {
		background-color: $athens-gray;
	}
}

.accordion-custom-table__item {
	&.is-open {
		.accordion-custom-table__button-arrow {
			transform: rotateX(-180deg);
		}
	}
}
.accordion-custom-table__button-name {
	padding: 2px 7px;
	font-family: $font-main;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	color: $white;
	border-radius: 8px;
	margin-right: 13px;
	background-color: rgb(255, 152, 0);

	@include mq($lg) {
		font-size: 14px;
	}

	@include mq(350px) {
		font-size: 13px;
		margin-right: 5px;
	}
}

.accordion-custom-table__button-num {
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	color: $shark;
	opacity: 0.5;

	@include mq($lg) {
		font-size: 12px;
	}

	@include mq(350px) {
		font-size: 11px;
	}
}

.accordion-custom-table__button-icon {
	position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
}

.accordion-custom-table__button-arrow {
	font-size: 27px;
    display: block;
	transition: $dur $ease;
	color: $fiord;
}

.accordion-custom-table__list-button {
	margin-bottom: 0;
	cursor: pointer;
}

.leader-header__button-arhive {
	@include mq(419px) {
		margin-top: 15px;
	}
}

.leader-header__button {
	transition: $dur $ease;
	justify-content: flex-end;
	margin-top: auto;

	@include mq(1800px) {
		max-width: 100%;
		align-items: center;
	}

	@include mq(640px) {
		justify-content: center;
	}
}

.property-history-header__wrapper {
    position: relative;
	min-width: 179px;
	width: 100%;
	border-radius: 8px;
	border: 1px solid $fiord;
	background-color: $white;
	color: $fiord;
	font-family: $font-main;
    font-weight: 500;
    font-size: 14px;
    line-height: 1;
    outline: none;
    cursor: pointer;
	transition: $dur $ease;

	@include hover {
		border: 1px solid $dodger-blue;
		color: $dodger-blue;

		.property-history-header__wrapper-btn:after {
			border-color: $dodger-blue transparent;
		}

		.property-history-header__dropdown {
			border: 1px solid $dodger-blue;
			border-top: 0;
		}
	}
}
.property-history-header__wrapper > .property-history-header__wrapper-btn {
	width: 100%;
	display: flex;
	align-items: center;
	border: none;
	padding: 10px 11px;

	@include mq($md) {
		padding: 9px;
	}
}

.property-history-header__wrapper-btn:after {
	content: "";
	width: 0;
	height: 0;
	position: absolute;
	right: 16px;
	top: calc(50% + 4px);
	margin-top: -6px;
	border-width: 6px 6px 0 6px;
	border-style: solid;
	border-color: $fiord transparent;
	transition: $dur $ease;
}
.property-history-header__dropdown {
	position: absolute;
	z-index: 10;
	top: 98%;
	left: -1px;
	right: 0;
	font-weight: normal;
	list-style-type: none;
	padding-left: 0;
	margin: 0;
	border: 1px solid $fiord;
	border-top: 0;
	background-color: $white;
	transition: $dur $ease;
	width: 101.2%;
	border-bottom-right-radius: 14px;
    border-bottom-left-radius: 14px;
}

.property-history-header__dropdown-item {
	display: block;
	text-decoration: none;
	color: $fiord;
	cursor: pointer;
	transition: $dur $ease;

	&:not(:last-of-type) {
		border-bottom: 1px solid $grey-light;
	}

	@include hover {
		background-color: $athens-gray;
		.property-history-header__dropdown-link {
			color: $dodger-blue;
		}
	}
}

.property-history-header__file-icon {
	padding: 0;
	font-size: 18px;
	margin-right: 12px;
	/* transition: $dur $ease; */
}

.property-history-header__dropdown-link {
	font-family: $font-main;
    font-size: 14px;
	padding: 10px;
	display: block;
	color: $fiord;
	transition: $dur $ease;
	text-decoration: none;
}

.property-history-header__buttons {
	display: flex;

	@include mq($lg) {
		width: 100%;
		justify-content: space-between;
		flex-wrap: wrap;
	}
}
.property-history-header__download-btn {
	margin: 0 15px;

	@include mq($xl) {
		margin: 10px 15px;
	}

	@include mq($md) {
		margin: 10px 7px;
	}
}

.leader-header__container {
	position: fixed;
	top: 84px;
	width: 100%;
	left: 50%;
	transform: translateX(-50%);
	transition: $dur $ease;
	z-index: 9999;
	background-color: $white;
	
	@include mq($xl) {
		top: 60px;
		right: 0;
		transform: none;
		left: 0;
	}

	@include mq(1800px) {
		flex-direction: column;
		align-items: inherit;
	}
}

.leader-header__container-wrap {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	flex-wrap: wrap;
	max-width: 1286px;
	margin: 0 auto;
	height: 100%;

	@include mq($sm) {
		width: 90%;
		margin: 0 auto;
	}
}

.leader-header__filters {
	padding-top: 15px;

	@include mq(1500px) {
		padding-top: 0;
	}
}

.leader-header__container-holder {
	display: flex;
	&.leader-header__container-scroll {
		box-shadow: 0px 9px 17px -12px $black;
	}
}

.leader-header__breadcrumb {
	transition: $dur $ease;
	@include mq(1800px) {
		margin-bottom: 20px;
		max-width: 100%;
	}
	@include mq(830px) {
		align-self: baseline;
	}
}

.breadcrumbs__link {
	cursor: pointer;
}

.properties-header__info-btn {
	max-width: 220px;
	padding: 10px;
}

.page-property-history__header-matching-buttons {
	display: flex;
	align-items: center;

	@include mq(830px) {
		margin-top: 15px;
		margin-left: auto;
	}

	@include mq(530px) {
		flex-direction: column;
		justify-content: center;
		margin: 15px auto 0;
	}
}

.header-matching-properties__selected-items {
	display: block;
    width: 100%;
    margin-left: auto;
    text-align: right;
    margin-top: 10px;
	font-family: $font-main;
    font-size: 13px;
	color: $fiord;
	transition: $dur $ease;
	opacity: 0;

	@include mq($sm) {
		font-size: 12px;
	}

	&.show {
		opacity: 1;
	}
}

</style>
